// extracted by mini-css-extract-plugin
export default {"WixStudioSimpleSplit__title":"T9axfZ","wixStudioSimpleSplitTitle":"T9axfZ","WixStudioSimpleSplit__text":"Qv97GM","wixStudioSimpleSplitText":"Qv97GM"};